import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Input, Button, Select, Popconfirm, Popover, Row, Col } from 'antd';
import { CKEditor } from 'components/atoms';
import { useMailTemplateDetail, useRefCode } from 'hooks'
import { QuestionCircleOutlined } from '@ant-design/icons'

export interface MailSendModalProps extends PopupProps {
    id: number;
    mail_type: string;
}

const MailTemplateEditModal = ({ isOpen, onClose, id, mail_type }: MailSendModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [mailBody, setMailBody] = useState<string>('');  
  const [mailGroup, setMailGroup] = useState<string>(mail_type);
  
  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList } = useRefCode({field: mailGroup+'_mail_type', status_type: 'AV'});   
  const { tmpplateInfo, mailTemplateInsert, mailTemplateSave, mailTemplateDelete, insertSuccess, updateSuccess, deleteSuccess } = useMailTemplateDetail(id, mail_type)

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

  const makePopupContent = () => {  
    return (
    <div className='schedule_popup' style={{width:'380px', fontSize:'12px'}}>
    <Row>
      <Col flex={'200px'}>◦교육생 이름</Col>
      <Col flex={'180px'}>[$userName]</Col>
    </Row>                                      
    <Row>
      <Col flex={'200px'}>◦교육생 메일</Col>
      <Col flex={'180px'}>[$user_email]</Col>
    </Row>   
    <Row>
      <Col flex={'200px'}>◦교육생 등록일</Col>
      <Col flex={'180px'}>[$reg_dttm]</Col>
    </Row>                                   
    <Row>
      <Col flex={'200px'}>◦교육생 등록일 + 1일</Col>
      <Col flex={'180px'}>[$reg_dttm_plus1]</Col>
    </Row>                                                          
    <Row>
      <Col flex={'200px'}>◦교육담당자 이름</Col>
      <Col flex={'180px'}>[$edu_name]</Col>
    </Row>                                
    <Row>
      <Col flex={'200px'}>◦교육담당자 메일</Col>
      <Col flex={'180px'}>[$edu_email]</Col>
    </Row>   
    <Row>
      <Col flex={'200px'}>◦교육담당자 연락처</Col>
      <Col flex={'180px'}>[$edu_tel]</Col>
    </Row>                                                                        
    <Row>
      <Col flex={'200px'}>◦결제담당자 이름</Col>
      <Col flex={'180px'}>[$acc_name]</Col>
    </Row>                                 
    <Row>
      <Col flex={'200px'}>◦결제담당자 메일</Col>
      <Col flex={'180px'}>[$acc_email]</Col>
    </Row> 
    <Row>
      <Col flex={'200px'}>◦회사명</Col>
      <Col flex={'180px'}>[$company_name]</Col>
    </Row>  
    <Row>
      <Col flex={'200px'}>◦결제방법</Col>
      <Col flex={'180px'}>[$ebill_yn]</Col>
    </Row>   
    <Row>
      <Col flex={'200px'}>◦계산서발행일</Col>
      <Col flex={'180px'}>[$ebill_etc]</Col>
    </Row>                                     
    <Row>
      <Col flex={'200px'}>◦총교육비</Col>
      <Col flex={'180px'}>[$pay_amt]</Col>
    </Row>   
    <Row>
      <Col flex={'200px'}>◦총교육비 ALL</Col>
      <Col flex={'180px'}>[$pay_amt_all]</Col>
    </Row>   
    <Row>
      <Col flex={'200px'}>◦과정명</Col>
      <Col flex={'180px'}>[$lecture_name]</Col>
    </Row>     
    <Row>
      <Col flex={'200px'}>◦교육일(매주,격주 요일)</Col>
      <Col flex={'180px'}>[$day_nm]</Col>
    </Row>   
    <Row>
      <Col flex={'200px'}>◦교육시간</Col>
      <Col flex={'180px'}>[$lecture_time]</Col>
    </Row>                                    
    <Row>
      <Col flex={'200px'}>◦교육과정 링크</Col>
      <Col flex={'180px'}>[$info_link]</Col>
    </Row>
    <Row>
      <Col flex={'200px'}>◦오프라인 교육장소</Col>
      <Col flex={'180px'}>[$location]</Col>
    </Row>                                  
    <Row>
      <Col flex={'200px'}>◦교육지도링크</Col>
      <Col flex={'180px'}>[$map]</Col>
    </Row>                                                                                                                                                                                                                                                                                    
    <Row>
      <Col flex={'200px'}>◦OT자료링크</Col>
      <Col flex={'180px'}>[$otdata]</Col>
    </Row> 
    <Row>
      <Col flex={'200px'}>◦(2인 이상 신청 시 10%할인 적용)</Col>
      <Col flex={'180px'}>[$dc_y_text]</Col>
    </Row>    
    <Row>
      <Col flex={'200px'}>◦수료증</Col>
      <Col flex={'180px'}>[$certificate_image]</Col>
    </Row>                                          
    <Row>
      <Col flex={'200px'}>◦수료증 다운로드</Col>
      <Col flex={'180px'}>[$certificate_download]</Col>
    </Row>                                                                                        
  </div>    
  )};

  /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
      onClose?.(insertSuccess || updateSuccess);
    };

    const onCopy = () => {
        mailTemplateInsert({
            id: 0,
            mail_type: form.getFieldValue('mail_type'),
            subject: form.getFieldValue('subject'),
            mail_group: form.getFieldValue('mail_group'),
            mail_type_name: form.getFieldValue('mail_type_name'),
            mail_body: mailBody,
            mail_to: form.getFieldValue('mail_to'),
            mail_cc: form.getFieldValue('mail_cc'),
        });
    };    
        
    const onDelete = () => {
        mailTemplateDelete({
            id: id,
            mail_type : mail_type
        })   
    };  

    const onSubmit = (e) => {
        const saveData = {
            id: id,
            mail_type: e.mail_type,
            subject: e.subject,
            mail_group: e.mail_group,
            mail_type_name: e.mail_type_name,
            mail_body: mailBody,
            mail_to: e.mail_to,
            mail_cc: e.mail_cc
        }
        if (id > 0) {
            mailTemplateSave(saveData);
        } else {
            mailTemplateInsert(saveData);
        }
    };
    
    /* ======================================================
    * methods
    * ====================================================== */
 
       
  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    form.setFieldValue("mail_group", mail_type);
        if (!!tmpplateInfo) {
            form.setFieldsValue({
                subject: tmpplateInfo.subject,
                mail_type: tmpplateInfo.mail_type,
                mail_type_name: tmpplateInfo.mail_type_name,
                mail_group: tmpplateInfo.mail_group,
                mail_to: tmpplateInfo.mail_to,
                mail_cc: tmpplateInfo.mail_cc,
                mail_body: tmpplateInfo.mail_body,
            });
            setMailBody(tmpplateInfo.mail_body); 
            setMailGroup(tmpplateInfo.mail_group)
        }
    }, [tmpplateInfo]);


    useEffect(() => {
      if (deleteSuccess) {
        onClose?.(true);
      }
    }, [deleteSuccess]);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={1000} title={'메일 템플릿'} closable>
            <Form
                form={form}
                name="LecturerInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >   
                <Form.Item name="mail_group" label={'메일그룹'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        placeholder={'메일그룹선택'}
                        style={{width:'120px'}}                     
                        onSelect={(value)=>setMailGroup(value)}
                        options={[
                        {label: '공개과정', value:'lecture'},
                        {label: '성과백신', value:'pml'},
                        {label: '세미나', value:'seminar'}
                        ]}
                    />
                </Form.Item>                  
                {(!!tmpplateInfo) && (
                <Form.Item label={'생성시간'}>
                    <label>{tmpplateInfo.created_at}</label>
                </Form.Item> 
                )}    
                <Form.Item name="mail_type" label={'유형'} rules={[{ required: true, message: '' }]}>
                  <Select placeholder="유형을 선택하세요" options={refCodeList?.map((item) => {return {label: item.value, value: item.name}})} />                
                </Form.Item>                               
                <Form.Item name="mail_type_name" label={'유형명'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='유형명을 입력하세요'/>                    
                </Form.Item>                  
                <Form.Item 
                    name="subject" 
                    label={                      
                        <Popover 
                            placement="rightTop" 
                            content={makePopupContent}
                        >
                          제목 <QuestionCircleOutlined />
                        </Popover>
                        } 
                    rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='메일 제목을 입력하세요'/>                    
                </Form.Item>      
                <Form.Item 
                    name="mail_to" 
                    label={                      
                        <Popover 
                            placement="rightTop" 
                            content={
                                <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
                                <Row>
                                  <Col flex={'120px'}>◦교육생 메일</Col>
                                  <Col flex={'180px'}>[$user_email]</Col>
                                </Row>    
                                <Row>
                                  <Col flex={'120px'}>◦교육담당자 메일</Col>
                                  <Col flex={'180px'}>[$edu_email]</Col>
                                </Row>         
                                <Row>
                                  <Col flex={'120px'}>◦결제담당자 메일</Col>
                                  <Col flex={'180px'}>[$acc_email]</Col>
                                </Row> 
                                <Row>
                                  <Col flex={'120px'}>◦직접입력</Col>
                                  <Col flex={'180px'}>예) info@hsg.or.kr</Col>
                                </Row>                                 
                              </div>
                            }
                        >
                          받는사람 <QuestionCircleOutlined />
                        </Popover>
                        } 
                    rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='이메일을 입력하세요'/>                    
                </Form.Item>   
                <Form.Item 
                    name="mail_cc" 
                    label={                      
                        <Popover 
                            placement="rightTop" 
                            content={
                                <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
                                <Row>
                                  <Col flex={'120px'}>◦교육생 메일</Col>
                                  <Col flex={'180px'}>[$user_email]</Col>
                                </Row>    
                                <Row>
                                  <Col flex={'120px'}>◦교육담당자 메일</Col>
                                  <Col flex={'180px'}>[$edu_email]</Col>
                                </Row>         
                                <Row>
                                  <Col flex={'120px'}>◦결제담당자 메일</Col>
                                  <Col flex={'180px'}>[$acc_email]</Col>
                                </Row> 
                                <Row>
                                  <Col flex={'120px'}>◦직접입력</Col>
                                  <Col flex={'180px'}>예) info@hsg.or.kr</Col>
                                </Row> 
                              </div>
                            }
                        >
                          참조 <QuestionCircleOutlined />
                        </Popover>
                        } 
                    >
                    <Input type="text" placeholder='이메일을 입력하세요'/>                    
                </Form.Item>       
                <Form.Item 
                    name="mail_body" 
                    label={                      
                        <Popover 
                            placement="rightTop" 
                            content={makePopupContent}
                        >
                          내용 <QuestionCircleOutlined />
                        </Popover>
                        } 
                    >
                    <CKEditor 
                        className='ck-reply-writer'
                        data={tmpplateInfo?.mail_body}
                        onSetData={setMailBody}
                    />  
                </Form.Item> 
                <ButtonGroup className={'buttonsWrapper'}>
                    <div>
                        <Button style={{marginRight: "5px"}} onClick={onCancel}>닫기</Button>
                        {(mail_type !== '') && (<Button style={{marginRight: "5px"}} onClick={onCopy}>복사</Button>)}
                    </div>                    
                    <div>
                        {(mail_type !== '') && (
                            <Popconfirm
                                title="삭제 하시겠습니까?"
                                okText="삭제"
                                cancelText="취소"
                                onConfirm={onDelete}
                            >   
                                <Button danger style={{marginRight: "5px"}}>삭제</Button>        
                            </Popconfirm>                            
                        )}
                        <Button htmlType="submit"  type="primary" >저장</Button>
                    </div>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(MailTemplateEditModal);    